import { TextField } from "@mui/material";
import validator from 'validator'
const UseInfoEmail = ({ isEdit, userInfo, setUserInfo, validateStatus, setValidateStatus }) => {
  const emailHandler = (e) => {
    const email = e.target.value;
    const isValid = validator.isEmail(email);
    setValidateStatus(prev => ({
      ...prev,
      email: {
        valid: isValid,
        message: isValid ? '' : '有効なメールアドレスを入力してください',
      }
    }));
    setUserInfo(prev => ({ ...prev, email: email }));
  }
  return <>
    <dt>メールアドレス{isEdit && <span>※</span>}</dt>
    <dd>
      {
        isEdit ? <div style={{ display: `grid`, gap: `8px` }}>
          <TextField value={userInfo.email}
            error={!validateStatus.email.valid}
            onInput={emailHandler}
            InputProps={{
              sx: {
                '& input': {
                  padding: '8px 16px',
                },
              },

            }}
            sx={{
              width: '100%'              // コンポーネントの幅を100%
            }}
          ></TextField>
          {validateStatus.email.message !== '' &&
            <span className="error" >{validateStatus.email.message}</span>
          }
        </div>
          :
          <span>{userInfo.email}</span>
      }
    </dd>

  </>
}
export default UseInfoEmail;
